export const StatsThreshhold = {
  models: 12000,
  datasets: 10000,
  organizations: 50,
  sectors: 100,
};
